import { render, staticRenderFns } from "./sanden-compressors.vue?vue&type=template&id=21616621&"
import script from "./sanden-compressors.vue?vue&type=script&lang=js&"
export * from "./sanden-compressors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports